module.exports = __webpack_public_path__ + "static/media/rsvpp.66a7ef16.jpeg";